export default __webpack_public_path__ + "static/media/FreshAir.b72d8afd.png";